<template>
  <div :class="$style.container">
    <ChatWindow
      :messages="messages"
      :requestUrl="requestUrl"
      :requestParams="requestParams"
      :focus="focus"
      :read-only="readOnly"
      errorName="message" />
  </div>
</template>

<script>
  import moment from 'moment'
  import ChatWindow from 'vue-components/chat-window/chat-window'
  import store from '@/lib/store'

  export default {
    components: {
      ChatWindow
    },
    props: {
      focus: { type: Boolean },
      activity: { type: Object },
      requestUrl: {
        type: String,
        default: ''
      },
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        user: store.get('user')
      }
    },
    computed: {
      messages () {
        return this.activity.privateMessages.map(message => {
          return {
            id: message.id,
            message: message.message,
            user: {
              name: message.participant.name,
              photoUrl: message.participant.user.photoUrl
            },
            align: this.user.id === message.participant.user.id ? 'right' : 'left'
          }
        })
      }
    },
    methods: {
      requestParams (message) {
        let elapsedSeconds

        if (this.activity.actualStartTime) {
          const start = moment.utc(this.activity.actualStartTime)
          elapsedSeconds = moment.utc().diff(start) / 1000
        } else {
          elapsedSeconds = 0
        }

        return {
          message,
          time: elapsedSeconds,
          private: true
        }
      }
    }
  }
</script>

<style module lang="less" src="./chat-window.less"></style>



// WEBPACK FOOTER //
// chat-window.vue?f8705e7c